const images = {
    logo: require('./logo.svg').default,
    personal: require('./personal.png'),
    band: require('./band.png'),
    tiktok: require('./tiktok.png'),
    music_app: require('./music_app.png'),
    dashboard: require('./dashboard.png'),
    shopee: require('./shopee.png'),
    zaloqr: require('./zalo.jpg'),
    instagram: require('./instagram.png'),
    gmail: require('./gmail.png'),
    f8: require('./f8.png'),
    interstellar: require('./interstellar.jpg'),
    dayconlamgiau: require('./dayconlamgiau.jpg'),
    ganhganhgonggong: require('./ganhganhgonggong.jpg'),
    minions: require('./minions.jpg'),
    thelionking: require('./thelionking.jpg'),
    vutruquan: require('./vutruquan.jpg'),
    danglenguyenvu: require('./danglenguyenvu.png'),
    einstein: require('./einstein.jpeg'),
    thayminhniem: require('./thayminhniem.png'),
    thomasedison: require('./thomasedison.jpg'),
    inkscape: require('./inkscapeLogo.svg').default,
    theboy_coding: require('./the_boy_coding.svg').default,
};

export default images;
